export default "__VITE_ASSET__BrALUwUX__"